import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge sólo conoce la escala por omisión de Tailwind. Sin esto, un
 * token propio se confunde con un color y se pierde al combinar clases:
 * `cn('shadow-card', 'shadow-primary/20')` se quedaba sin la sombra, y
 * `text-2xs` competía con `text-muted-foreground`. Los nombres salen de
 * `tailwind.config.js` (spec 310 §3).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs'] }],
      shadow: [{ shadow: ['card', 'overlay', 'dialog'] }],
      rounded: [{ rounded: ['boton', 'tarjeta'] }],
      duration: [{ duration: ['snap', 'base', 'overlay', 'move'] }],
      ease: [{ ease: ['snap', 'move'] }],
    },
  },
});

/**
 * Combina clases de Tailwind CSS de manera inteligente
 * Usa clsx para condicionales y tailwind-merge para evitar conflictos
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
